import { useTranslation } from "react-i18next";
import type { PartyRoleSummary } from "@/lib/types";

// A role as a chip, with the number that goes with it: "Klant VR10231",
// "Charter IR20017". An ended role stays visible, muted; a blocked charter says so.
export function RoleChip({ role }: { role: PartyRoleSummary }) {
  const { t } = useTranslation();
  const label = t(role.role === "customer" ? "parties.roleCustomer" : "parties.roleCharter");
  const tone = role.role === "customer" ? "wl-chip--brand" : "wl-chip--navy";
  return (
    <span className={`wl-chip ${role.isActive ? tone : ""}`}>
      {label}
      {role.number && (
        <span className="t-mono" style={{ marginLeft: "4px" }}>
          {role.number}
        </span>
      )}
      {!role.isActive && <span style={{ marginLeft: "4px", opacity: 0.75 }}>· {t("parties.roleEnded")}</span>}
      {role.isActive && role.approval === "blocked" && (
        <span style={{ marginLeft: "4px", opacity: 0.85 }}>· {t("parties.chipBlocked")}</span>
      )}
    </span>
  );
}
